import { isPlansPageAllowed } from '../utils/user';
import { useUser } from './useUser';

/**
 * Hook that determines if user should be allowed to access the plans page
 * This is used to prevent users from being redirected to the plans page
 * if they are not an enterprise user or if they are not a team owner
 */
export const useIsPlansPageAllowed = (
  isFreePlansOnly: boolean = false,
): {
  isPlansPageAllowed: boolean;
  isLoading: boolean;
} => {
  const { user, isLoading } = useUser();

  return {
    isPlansPageAllowed: isPlansPageAllowed(user, isFreePlansOnly),
    isLoading,
  };
};
